import Transfer from './src/main';

Transfer.install = function(Vue) {
  Vue.component(Transfer.name, Transfer);
};

export default Transfer;



// WEBPACK FOOTER //
// ./src/components/transfer/index.js